<script lang="ts">
	import BackToTop from './BackToTop.svelte';

	let { children, class: className = '' } = $props();
</script>

<main
	class="container mx-auto mb-28 min-h-screen w-full max-w-full py-4 sm:mb-20 sm:max-w-3xl md:max-w-7xl {className}"
	id="main"
>
	{@render children()}
	<BackToTop></BackToTop>
</main>
